import { ROUTES, ROUTE_PERMISSIONS, USER_ROLES } from './constants';

/**
 * Checks if a user's role grants them access to a specific route.
 * @param {string} userRole - The role of the user (e.g., 'Admin').
 * @param {string} path - The route path to check (e.g., '/dashboard').
 * @returns {boolean} - True if the user has access, otherwise false.
 */
export const hasRouteAccess = (userRole, path) => {
  if (!userRole || !path) {
    return false;
  }

  // Get the list of allowed routes for the user's role.
  const allowedRoutes = ROUTE_PERMISSIONS[userRole] || [];
  
  // Check if the requested path is in the list.
  return allowedRoutes.includes(path);
};

/**
 * Gets the default landing page for a user based on their role.
 * @param {string} userRole - The role of the user.
 * @returns {string} - The default route for the user.
 */
export const getDefaultRoute = (userRole) => {
  switch (userRole) {
    case USER_ROLES.NLA_ADMIN:
      return ROUTES.NLA_ADMIN_DASHBOARD;
    default:
      return ROUTES.DASHBOARD;
  }
};


// // src/utils/routeUtils.js
// import { ROUTES, ROUTE_PERMISSIONS, USER_ROLES, ROLE_LEVELS } from './constants';

// /**
//  * Check if a user has permission to access a specific route
//  * @param {string} userRole - Current user's role
//  * @param {string} route - Route to check
//  * @returns {boolean} - Whether user has access
//  */
// export const hasRouteAccess = (userRole, route) => {
//   if (!userRole || !route) return false;

//   // Public routes are accessible to everyone
//   if (ROUTE_PERMISSIONS.PUBLIC.includes(route)) {
//     return true;
//   }

//   // Check if user is authenticated for authenticated routes
//   if (ROUTE_PERMISSIONS.AUTHENTICATED.includes(route)) {
//     return true; // Assumes this function is only called for authenticated users
//   }

//   // Check content creator routes
//   if (ROUTE_PERMISSIONS.CONTENT_CREATORS.includes(route)) {
//     return [
//       USER_ROLES.JOURNALIST,
//       USER_ROLES.INFLUENCER,
//       USER_ROLES.STATION_MANAGER,
//       USER_ROLES.ADMIN,
//       USER_ROLES.NLA_ADMIN,
//     ].includes(userRole);
//   }

//   // Check manager routes
//   if (ROUTE_PERMISSIONS.MANAGERS.includes(route)) {
//     return [
//       USER_ROLES.STATION_MANAGER,
//       USER_ROLES.ADMIN,
//       USER_ROLES.NLA_ADMIN,
//     ].includes(userRole);
//   }

//   // Check admin only routes
//   if (ROUTE_PERMISSIONS.ADMIN_ONLY.includes(route)) {
//     return [USER_ROLES.ADMIN, USER_ROLES.NLA_ADMIN].includes(userRole);
//   }

//   // Check NLA admin only routes
//   if (ROUTE_PERMISSIONS.NLA_ADMIN_ONLY.includes(route)) {
//     return userRole === USER_ROLES.NLA_ADMIN;
//   }

//   return false;
// };

// /**
//  * Get accessible routes for a user role
//  * @param {string} userRole - User's role
//  * @returns {string[]} - Array of accessible routes
//  */
// export const getAccessibleRoutes = (userRole) => {
//   if (!userRole) return ROUTE_PERMISSIONS.PUBLIC;

//   const accessibleRoutes = [
//     ...ROUTE_PERMISSIONS.PUBLIC,
//     ...ROUTE_PERMISSIONS.AUTHENTICATED,
//   ];

//   // Add routes based on role hierarchy
//   const userLevel = ROLE_LEVELS[userRole] || 0;

//   if (userLevel >= ROLE_LEVELS[USER_ROLES.JOURNALIST]) {
//     accessibleRoutes.push(...ROUTE_PERMISSIONS.CONTENT_CREATORS);
//   }

//   if (userLevel >= ROLE_LEVELS[USER_ROLES.STATION_MANAGER]) {
//     accessibleRoutes.push(...ROUTE_PERMISSIONS.MANAGERS);
//   }

//   if (userLevel >= ROLE_LEVELS[USER_ROLES.ADMIN]) {
//     accessibleRoutes.push(...ROUTE_PERMISSIONS.ADMIN_ONLY);
//   }

//   if (userRole === USER_ROLES.NLA_ADMIN) {
//     accessibleRoutes.push(...ROUTE_PERMISSIONS.NLA_ADMIN_ONLY);
//   }

//   return [...new Set(accessibleRoutes)]; // Remove duplicates
// };

// /**
//  * Get the default route for a user based on their role
//  * @param {string} userRole - User's role
//  * @returns {string} - Default route
//  */
// export const getDefaultRoute = (userRole) => {
//   switch (userRole) {
//     case USER_ROLES.NLA_ADMIN:
//       return ROUTES.NLA_ADMIN_DASHBOARD;
//     case USER_ROLES.ADMIN:
//       return ROUTES.ADMIN_DASHBOARD;
//     case USER_ROLES.STATION_MANAGER:
//       return ROUTES.DASHBOARD;
//     case USER_ROLES.INFLUENCER:
//     case USER_ROLES.JOURNALIST:
//     default:
//       return ROUTES.DASHBOARD;
//   }
// };

// /**
//  * Check if a route requires a minimum role level
//  * @param {string} route - Route to check
//  * @param {string} userRole - User's role
//  * @returns {boolean} - Whether user meets minimum role requirement
//  */
// export const meetsMinimumRoleRequirement = (route, userRole) => {
//   const userLevel = ROLE_LEVELS[userRole] || 0;

//   // Define minimum role requirements for routes
//   const routeMinimumRoles = {
//     [ROUTES.USERS]: ROLE_LEVELS[USER_ROLES.ADMIN],
//     [ROUTES.ADMIN_DASHBOARD]: ROLE_LEVELS[USER_ROLES.ADMIN],
//     [ROUTES.ADMIN_SETTINGS]: ROLE_LEVELS[USER_ROLES.ADMIN],
//     [ROUTES.DEPOSITS]: ROLE_LEVELS[USER_ROLES.STATION_MANAGER],
//     [ROUTES.WITHDRAWALS]: ROLE_LEVELS[USER_ROLES.STATION_MANAGER],
//     [ROUTES.GAMES]: ROLE_LEVELS[USER_ROLES.STATION_MANAGER],
//     [ROUTES.PRODUCTS]: ROLE_LEVELS[USER_ROLES.JOURNALIST],
//     [ROUTES.CUSTOMERS]: ROLE_LEVELS[USER_ROLES.JOURNALIST],
//   };

//   const requiredLevel = routeMinimumRoles[route] || 0;
//   return userLevel >= requiredLevel;
// };

// /**
//  * Get navigation items based on user role
//  * @param {string} userRole - User's role
//  * @returns {Object[]} - Navigation items
//  */
// export const getNavigationItems = (userRole) => {
//   const accessibleRoutes = getAccessibleRoutes(userRole);
  
//   const allNavItems = [
//     { label: 'Dashboard', route: ROUTES.DASHBOARD, icon: 'dashboard' },
//     { label: 'Profile', route: ROUTES.PROFILE, icon: 'person' },
//     { label: 'Products', route: ROUTES.PRODUCTS, icon: 'inventory' },
//     { label: 'Customers', route: ROUTES.CUSTOMERS, icon: 'people' },
//     { label: 'Deposits', route: ROUTES.DEPOSITS, icon: 'add_circle' },
//     { label: 'Withdrawals', route: ROUTES.WITHDRAWALS, icon: 'remove_circle' },
//     { label: 'Games', route: ROUTES.GAMES, icon: 'sports_esports' },
//     { label: 'Users', route: ROUTES.USERS, icon: 'admin_panel_settings' },
//     // { label: 'Admin Dashboard', route: ROUTES.ADMIN_DASHBOARD, icon: 'admin_panel_settings' },
//     { label: 'Settings', route: ROUTES.ADMIN_SETTINGS, icon: 'settings' },
//   ];

//   return allNavItems.filter(item => accessibleRoutes.includes(item.route));
// };

// export default {
//   hasRouteAccess,
//   getAccessibleRoutes,
//   getDefaultRoute,
//   meetsMinimumRoleRequirement,
//   getNavigationItems,
// };